export default {
  title: 'Protocol',
  subtitle: 'Titron Protocol',
  description: 'Building the foundational protocol for Web3 privacy protection and data sovereignty, enabling secure data sharing and value utilization with verifiability',
  layers: {
    privacyLayer: {
      title: 'Privacy Protection Layer',
      subtitle: 'Privacy Protection Layer',
      description: 'Zero-knowledge proofs and homomorphic encryption technology, achieving verifiable but invisible data'
    },
    identityLayer: {
      title: 'Data Identity Layer',
      subtitle: 'Data Identity Layer',
      description: 'Decentralized identity management, users possess complete digital sovereignty'
    },
    economyLayer: {
      title: 'Smart Economy Layer',
      subtitle: 'Smart Economy Layer',
      description: 'Privacy-protected smart contracts, building decentralized data trading market'
    },
    interopLayer: {
      title: 'Interoperability Layer',
      subtitle: 'Interoperability Layer',
      description: 'Cross-chain compatibility, extending privacy protection capabilities to the entire multi-chain ecosystem'
    }
  },
  principles: {
    title: 'Design Principles',
    privacyFirst: {
      title: 'Privacy First',
      description: 'Privacy First',
      detail: 'Making user privacy protection the primary principle of protocol design'
    },
    userSovereignty: {
      title: 'User Sovereignty',
      description: 'User Sovereignty',
      detail: 'Users have complete control over their own data and identity'
    },
    verifiableComputing: {
      title: 'Verifiable Computing',
      description: 'Verifiable Computing',
      detail: 'Ensuring correctness and verifiability of computation results'
    },
    decentralization: {
      title: 'Decentralization',
      description: 'Decentralization',
      detail: 'No single point of failure, censorship-resistant and uncontrolled'
    }
  },
  architecture: {
    title: 'Architecture Design',
    heading: 'Layered Architecture Design',
    description: 'Titron protocol adopts layered architecture design, with each layer having clear responsibilities and functions'
  },
  cta: {
    title: 'Start Using Titron Protocol',
    description: 'Join our developer community and start building privacy-protected Web3 applications',
    button: 'Start Building'
  }
};
